import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc88e0be"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex flex-column w-full gap-3"
}
const _hoisted_2 = { class: "flex gap-2 w-full align-items-center" }
const _hoisted_3 = { class: "font-semibold text-xl" }
const _hoisted_4 = { class: "flex gap-2 flex-column sm:flex-row" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "flex flex-column text-sm w-full gap-2" }
const _hoisted_7 = { class: "flex justify-content-between gap-3" }
const _hoisted_8 = { class: "flex gap-1" }
const _hoisted_9 = { class: "font-semibold" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-600" }, "kcal", -1))
const _hoisted_11 = { class: "text-green-500 font-semibold" }
const _hoisted_12 = { class: "flex justify-content-between gap-3" }
const _hoisted_13 = { class: "flex gap-1" }
const _hoisted_14 = { class: "font-semibold" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-600" }, "g CO2", -1))
const _hoisted_16 = { class: "flex gap-1" }
const _hoisted_17 = { class: "text-600" }
const _hoisted_18 = { class: "font-semibold" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-chevron-right text-xs text-600" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconLeaf = _resolveComponent("IconLeaf")!
  const _component_IconWalk = _resolveComponent("IconWalk")!
  const _component_IconBike = _resolveComponent("IconBike")!

  return (_ctx.greenestRoutes.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_IconLeaf, { class: "text-2xl text-primary" }),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("route_planner.green_routes")), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.greenestRoutes, (route) => {
            return (_openBlock(), _createElementBlock("button", {
              key: route.legs[0].mode,
              class: "plainButton green-card",
              onClick: ($event: any) => (_ctx.handleRouteSelection(route))
            }, [
              (route.legs[0].mode === 'WALK')
                ? (_openBlock(), _createBlock(_component_IconWalk, {
                    key: 0,
                    class: "thin-icon text-3xl flex-shrink-0"
                  }))
                : (_openBlock(), _createBlock(_component_IconBike, {
                    key: 1,
                    class: "thin-icon text-3xl"
                  })),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(Math.round(_ctx.convertJoulesToKcal(route.humanEffort.value))), 1),
                    _hoisted_10
                  ]),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.formatDuration(route)), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(Math.round(route.co2Emissions.value)), 1),
                    _hoisted_15
                  ]),
                  _createElementVNode("span", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.timeModeSelection === "departure"
                  ? _ctx.$t("route_planner.arrival")
                  : _ctx.$t("route_planner.departure")), 1),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.timeModeSelection === "departure"
                  ? _ctx.getArrivalTime(route)
                  : _ctx.getDepartureTime(route)), 1)
                  ])
                ])
              ]),
              _hoisted_19
            ], 8, _hoisted_5))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}